import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';
import db from '../dbconn';
import {API_ROOT} from './../api-config';
import Modal from 'react-responsive-modal';
import payform from 'payform';
import Swal from "sweetalert2";
import aes256 from 'aes256';
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

class addCard extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            open: false,
            nosessionredirect: false,
            card_id: this.props.match.params.cardId,
            categoryList: [],
            swalButton: '',
            cardDate:'',

            key: 'x!A%D*G-KaPdSgVkYp3s5v8y/B?E(H+M'
        };
        this.updateState = this.updateState.bind(this);
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };


    updateState(e) {
        this.setState({});

    }

    componentWillMount() {

        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        var url = '';
        var customer_id, customer_token;

        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            }

        });
    }

    componentDidMount() {

        document.title = "Add Card - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});

        var cardField = document.getElementById('cardNumberTxt');
        payform.cardNumberInput(cardField);

        $("#cardMonth").on("change keyup paste", function () {

            var text = $(this).val();
            var textlength = $(this).val().length;

            if (text.endsWith("/")) {
                return;
            }
            if (textlength == 3) {
                $(this).val([text.slice(0, 2), "/", text.slice(2)].join(''));
            }
        });

        $('#saveCardBtn').click(e => {

            var allGood = false;

            var dbconn = new db();

            dbconn.getAll().then(data => {

                var monthTxt = $('#cardMonth').val().split("/");

                var url = '';

                if (this.state.card_id == 0) {
                    url = API_ROOT + '/addcard';
                } else {
                    url = API_ROOT + '/updatecard';
                }

                var cardNumber = $('#cardNumberTxt').val();
                var cardName = $('#cardNameTxt').val();
                var cardCvv = $('#cardCvvTxt').val();
                var cardZip = $('#cardZipTxt').val();
                var cardMonth = monthTxt[0];
                var cardYear = monthTxt[1];

                if (this.toVerify()) {

                    this.onOpenModal();
                    axios.post(url, {
                        customer_id: data[0].customer_id,
                        customer_token: data[0].customer_token,
                        card_number: aes256.encrypt(this.state.key, cardNumber),
                        card_name: aes256.encrypt(this.state.key, cardName),
                        card_month: aes256.encrypt(this.state.key, cardMonth),
                        card_year: aes256.encrypt(this.state.key, cardYear),
                        card_cvv: aes256.encrypt(this.state.key, cardCvv),
                        card_zip: aes256.encrypt(this.state.key, cardZip),
                        card_id: this.state.card_id,
                        card_type: aes256.encrypt(this.state.key, payform.parseCardType(cardNumber)),
                        store_id: localStorage.getItem("store_id"),
                    })
                        .then(response => {

                            this.onCloseModal();

                            if (response.data.status == 1) {
                                this.setState({redirect: true});
                            } else {

                                this.state.swalButton.fire({title: response.data.message, allowOutsideClick: false});

                            }
                        })
                        .catch(error => {
                            this.onCloseModal();
                            console.log(error);
                        });
                }
            });
        });
    }

    normalizeInput = (value, previousValue) => {
        if (!value) return value;
        var currentValue = value.replace(/[^\d]/g, '');
        var cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 2) return currentValue;

            console.log(currentValue.slice(0, 2) + " " + currentValue.slice(1));
            if (cvLength < 4) return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
            return `${currentValue.slice(0, 2)}/${currentValue.slice(2)}`;
        }
    };

    cvvcheck = (event) => {

        const {value, maxLength} = event.target;
        const updatedCvv = value.slice(0, maxLength);

        $('#cardCvvTxt').val(updatedCvv);
    };

    zipcodecheck = (event) => {

        const {value, maxLength} = event.target;
        const updatedZip = value.slice(0, maxLength);

        $('#cardZipTxt').val(updatedZip);
    };
    handleChange = e => {

        this.setState({cardDate: this.normalizeInput($(e.target).val(), this.state.cardDate)});
    };

    toVerify() {

        var monthTxt = $('#cardMonth').val().split("/");
        var cardNumber = $('#cardNumberTxt').val();
        var cardName = $('#cardNameTxt').val();
        var cardCvv = $('#cardCvvTxt').val();
        var cardZip = $('#cardZipTxt').val();
        var cardMonth = monthTxt[0];
        var cardYear = monthTxt[1];


        var n = $('#cardMonth').val().search(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/i);


        //alert(n);
        if (cardNumber == '' ||
            cardNumber == null ||
            cardName == '' ||
            cardName == null ||
            cardCvv == '' ||
            cardCvv == null ||
            cardZip == '' ||
            cardZip == null ||
            cardMonth == '' ||
            cardMonth == null ||
            cardMonth == 0 ||
            cardYear == '' ||
            cardYear == null ||
            cardYear == 0) {


            this.state.swalButton.fire({title: i18n.t('details_validation'), allowOutsideClick: false});
            return false;
        } else if (n < 0) {
            this.state.swalButton.fire({title: i18n.t('expiry_validation'), allowOutsideClick: false});
            return false;

        }
        return true;
    }

    render() {

        const {open} = this.state;
        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        if (this.state.redirect) {
            return (<Redirect to={'/card/success'}/>);
        }

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/payment/methods'}></Link>
                        <h2 className="text-center">{t('payment_methods')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35  bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('add_card')}</h2>
                                </div>
                                <div className="header-content m-b-10">
                                    <img src="/img/payment_method_img.png" alt="Payment Method Image"/>
                                </div>


                                <div className="form-box">
                                    <div className="form-group m-label-none">
                                        <label className="">{t('cardholder')}</label>
                                        <input type="text" className="form-control" name="cardNameTxt" tabIndex="1"
                                               id="cardNameTxt"/>
                                    </div>
                                    <div className="form-group m-label-none">
                                        <label>{t('ccnumber')}</label>
                                        <input type="text" className="form-control" name="cardNumberTxt" tabIndex="2"
                                               id="cardNumberTxt" maxLength="20"/>
                                    </div>
                                    <div className="form-group  three-column m-r-1 m-label-none">
                                        <label>{t('expiry')}</label>
                                        <input name="expiry" className="form-control" id="cardMonth"
                                               value={this.state.cardDate || ''}
                                               onChange={this.handleChange} tabIndex="3" name="cardMonth"
                                               type="text" placeholder="MM/YY" maxLength="5"/>
                                    </div>
                                    <div className="form-group three-column m-r-1  m-label-none">
                                        <label>CVV/CVC</label>
                                        <input type="number" className="form-control" name="cardCvvTxt" tabIndex="4"
                                               id="cardCvvTxt"
                                               onChange={this.cvvcheck} maxLength="4"/>
                                    </div>
                                    <div className="form-group  three-column float_l m-label-none">
                                        <label>{t('zip_code')}</label>
                                        <input type="number" className="form-control" name="cardZipTxt" tabIndex="5"
                                               id="cardZipTxt"
                                               onChange={this.zipcodecheck} maxLength="5"/>
                                    </div>
                                    <div className="form-group">
                                        <input type="button" name="saveCardBtn" id="saveCardBtn" value={t('save_card')}/>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('adding_card')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>

                <div className="clearfix"></div>

            </div>


        );
    }
}


export default withRouter(withTranslation()(addCard));


// WEBPACK FOOTER //
// ./src/view_components/add_card.js